var render = function () {
  var _vm$bookingPresetMode;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "BookingSelectList"
    }
  })], 1)]), _c('b-card', {
    attrs: {
      "title": "預約日曆"
    }
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('b-row', {
    staticClass: "mt-2 mb-3",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('b-col', {
    attrs: {
      "sm": "4",
      "lg": "3"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.bookingPresetsOptions
    },
    model: {
      value: _vm.query.preset_id,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "preset_id", $$v);
      },
      expression: "query.preset_id"
    }
  })], 1), _vm.checkPermission([_vm.consts.BOOKING_CREATE]) ? _c('b-button', {
    staticClass: "flex-shrink-0 align-self-center ml-2",
    attrs: {
      "variant": "primary",
      "to": {
        name: 'BookingCenterBookingCreate',
        params: {
          id: _vm.query.preset_id
        },
        query: {
          branch_id: _vm.query.branch_id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" 新增預約 ")]) : _vm._e(), _c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-1-inner",
      modifiers: {
        "collapse-1-inner": true
      }
    }],
    staticClass: "flex-shrink-0 ml-2",
    attrs: {
      "variant": "link"
    }
  }, [_vm._v(" 進階搜尋"), _c('i', {
    staticClass: "fa fa-chevron-down ml-2"
  })]), _c('h6', {
    staticClass: "text-center mt-2 ml-auto"
  }, [_vm._v("預約筆數：" + _vm._s(_vm.fetchCount) + " / 總筆數：" + _vm._s(_vm.totalCount))])], 1), _c('b-collapse', {
    attrs: {
      "id": "collapse-1-inner"
    }
  }, [_c('div', {
    staticClass: "mt-2 mb-3 d-flex flex-column"
  }, [(_vm$bookingPresetMode = _vm.bookingPresetModel) !== null && _vm$bookingPresetMode !== void 0 && _vm$bookingPresetMode.isWizardMode ? _c('b-form-radio-group', {
    staticClass: "mb-2 d-flex align-items-center",
    attrs: {
      "disabled": !_vm.staffDisplayOptionsIsAvailable,
      "options": [{
        text: '顯示全部員工',
        value: 'all'
      }, {
        text: '僅顯示已預約員工',
        value: 'booked'
      }]
    },
    on: {
      "input": _vm.handleStaffResourceFilterChanged
    },
    model: {
      value: _vm.staffResourceFilter,
      callback: function callback($$v) {
        _vm.staffResourceFilter = $$v;
      },
      expression: "staffResourceFilter"
    }
  }) : _vm._e(), _c('AppMultiSelect', {
    staticClass: "mb-2",
    staticStyle: {
      "order": "0"
    },
    attrs: {
      "options": _vm.statusOptions,
      "disabled": _vm.showLoading || !this.query.preset_id
    },
    model: {
      value: _vm.query.status,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "status", $$v);
      },
      expression: "query.status"
    }
  }), _vm.showBranchSelect ? _c('AppSingleSelect', {
    staticClass: "mb-2",
    style: {
      order: _vm.deepGet(_vm.bookingPresetModel, 'wizardFieldOrder.branch', 1)
    },
    attrs: {
      "options": _vm.branchOptions,
      "disabled": _vm.showLoading || !this.checkPermission([_vm.consts.BOOKING_LIST_BRANCH])
    },
    on: {
      "input": _vm.handleBranchFilterChanged
    },
    model: {
      value: _vm.branch,
      callback: function callback($$v) {
        _vm.branch = $$v;
      },
      expression: "branch"
    }
  }) : _vm._e(), _vm.showStaffSelect ? _c('b-select', {
    staticClass: "mb-2",
    style: {
      order: _vm.deepGet(_vm.bookingPresetModel, 'wizardFieldOrder.staff', 2)
    },
    attrs: {
      "options": _vm.staffOptions,
      "disabled": _vm.showLoading || _vm.staffOptions.length <= 1
    },
    on: {
      "input": _vm.handleStaffFilterChanged
    },
    model: {
      value: _vm.query.staff_id,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "staff_id", $$v);
      },
      expression: "query.staff_id"
    }
  }) : _vm._e(), _vm.showServiceSelect ? _c('b-select', {
    staticClass: "mb-2",
    style: {
      order: _vm.deepGet(_vm.bookingPresetModel, 'wizardFieldOrder.service', 3)
    },
    attrs: {
      "options": _vm.serviceOptions,
      "disabled": _vm.showLoading
    },
    on: {
      "input": _vm.handleServiceFilterChanged
    },
    model: {
      value: _vm.query.service_id,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "service_id", $$v);
      },
      expression: "query.service_id"
    }
  }) : _vm._e()], 1)]), _c('div', {
    staticClass: "d-flex align-items-center mb-3"
  }, [_vm._v(" 快速跳至日期： "), _c('AppDatePicker', {
    staticStyle: {
      "width": "160px"
    },
    on: {
      "change": _vm.handleQuickJumpDateChanged
    },
    model: {
      value: _vm.quickJumpDate,
      callback: function callback($$v) {
        _vm.quickJumpDate = $$v;
      },
      expression: "quickJumpDate"
    }
  })], 1), _c('FullCalendar', {
    ref: "fullCalendar",
    attrs: {
      "options": _vm.calendarOptions
    },
    scopedSlots: _vm._u([{
      key: "eventContent",
      fn: function fn(arg) {
        return [_c('span', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(arg.event.extendedProps.title))]), _c('div', {
          staticClass: "floating-tooltip",
          attrs: {
            "id": "tooltip_".concat(arg.event.extendedProps.id),
            "role": "tooltip"
          }
        }, [_c('div', {
          staticClass: "popover",
          class: "bs-popover-".concat(_vm.placement)
        }, [_c('h3', {
          staticClass: "popover-header"
        }, [_vm._v(_vm._s(arg.event.extendedProps.title))]), _c('div', {
          staticClass: "popover-body"
        }, [_vm._l(_vm.bookingDetailFields, function (field) {
          return _c('div', {
            key: field.key
          }, [_c('span', [_vm._v(_vm._s(field.label) + "：" + _vm._s(_vm.deepGet(arg.event.extendedProps, field.key)))])]);
        }), _c('router-link', {
          attrs: {
            "to": {
              name: 'BookingCenterBookingEdit',
              params: {
                id: _vm.query.preset_id,
                booking_id: arg.event.extendedProps.id
              }
            }
          }
        }, [_c('span', {
          on: {
            "click": function click() {
              return _vm.closeTooltip();
            }
          }
        }, [_vm._v("查看明細")])])], 2), _c('span', {
          staticClass: "arrow",
          attrs: {
            "id": "arrow_".concat(arg.event.extendedProps.id)
          }
        })])])];
      }
    }])
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }